import Item from '../Item';
import BoaxelItem from '../boaxel/BoaxelItem';
import BrorSection from '../bror/Section';
import BoaxelSection from '../boaxel/Section';
import AurdalSection from '../aurdal/Section';
import IvarSection from '../ivar/Section';
import ElvarliSection from '../elvarli/Section';
import Shelf from '../Shelf';
import Legs from '../jonaxel/Legs';
import Frame from '../jonaxel/Frame';
import TopShelf from '../jonaxel/TopShelf';
import ShelvingUnit from '../jonaxel/ShelvingUnit';
import JonaxelClothesRail from '../jonaxel/ClothesRail';
import BoaxelClothesRail from '../boaxel/ClothesRail';
import AurdalClothesRail from '../aurdal/ClothesRail';
import Cover from '../jonaxel/Cover';
import Upright from '../boaxel/Upright';
import BoaxelMountingRail from '../boaxel/MountingRail';
import AurdalMountingRail from '../aurdal/MountingRail';
import { applicationSettings } from '../../settings/application';
import ProppingItem from '../ProppingItem';
import BoaxelProppingItem from '../boaxel/BoaxelProppingItem';
import AdjustableSection from '../boaxel/AdjustableSection';
import Sidewall from '../aurdal/Sidewall';
import BoaxelShelf from '../boaxel/BoaxelShelf';
import BoaxelTable from '../boaxel/Table';
import IvarShelf from '../ivar/IvarShelf';
import IvarDrawer from '../ivar/Drawer';
import IvarDoors from '../ivar/Doors';
import ElvarliShelf from '../elvarli/ElvarliShelf';
import ElvarliDrawer from '../elvarli/ElvarliDrawer';
import ElvarliShelfDrawer from '../elvarli/ElvarliShelfDrawer';
import ElvarliShelfClothesRail from '../elvarli/ElvarliShelfClothesRail';
import ElvarliClothesRail from '../elvarli/ElvarliClothesRail';
import { ITEMS } from '../../constants';

/**
 * Gets a new instance of the correct PIXI class for an item
 * @param {*} args
 * @returns {Object}
 */
export default function getComponent(args) {
  switch (args.item.type) {
    case ITEMS.DOOR:
      switch (applicationSettings.applicationName) {
        case 'IVAR':
          return new IvarDoors(args);
        default:
          return new Item(args);
      }
    case ITEMS.SECTION:
      switch (applicationSettings.applicationName) {
        case 'BROR':
          return new BrorSection(args);
        case 'BOAXEL':
          if (args.item.width >= 600) {
            return new BoaxelSection(args);
          }
          return new AdjustableSection(args);
        case 'AURDAL':
          return new AurdalSection(args);
        case 'IVAR':
          return new IvarSection(args);
        case 'ELVARLI':
          return new ElvarliSection(args);
        default:
          return new Item(args);
      }
    case ITEMS.SHELF:
    case ITEMS.METAL_SHELF:
    case ITEMS.WIRE_SHELF:
    case ITEMS.FELT_SHELF:
      switch (applicationSettings.applicationName) {
        case 'BOAXEL':
          return new BoaxelShelf(args);
        case 'IVAR':
          return new IvarShelf(args);
        case 'ELVARLI':
          return new ElvarliShelf(args);
        default:
          return new Shelf(args);
      }
    case ITEMS.SHELF_DRAWER:
      switch (applicationSettings.applicationName) {
        case 'IVAR':
          return new IvarDrawer(args);
        case 'ELVARLI':
          return new ElvarliShelfDrawer(args);
        default:
          return new Item(args);
      }
    case ITEMS.FRAME:
      return new Frame(args);
    case ITEMS.SHELVING_UNIT:
      return new ShelvingUnit(args);
    case 'leg':
      return new Legs(args);
    case 'cover':
      return new Cover(args);
    case ITEMS.TOP_SHELF:
      return new TopShelf(args);
    case ITEMS.CLOTHES_RAIL:
      switch (applicationSettings.applicationName) {
        case 'JONAXEL':
          return new JonaxelClothesRail(args);
        case 'BOAXEL':
          return new BoaxelClothesRail(args);
        case 'AURDAL':
          return new AurdalClothesRail(args);
        case 'ELVARLI':
          return new ElvarliClothesRail(args);
        default:
          return new Item(args);
      }
    case ITEMS.SHELF_CLOTHES_RAIL:
      switch (applicationSettings.applicationName) {
        case 'ELVARLI':
          return new ElvarliShelfClothesRail(args);
        default:
          return new Item(args);
      }
    case ITEMS.UPRIGHT:
      return new Upright(args);
    case ITEMS.DRYING_RACK:
    case ITEMS.TROUSER_HANGER:
    case ITEMS.SHOE_SHELF:
    case ITEMS.BOTTLE_RACK:
      switch (applicationSettings.applicationName) {
        case 'BOAXEL':
          return new BoaxelProppingItem(args);
        default:
          return new ProppingItem(args);
      }
    case ITEMS.DRAWER: {
      switch (applicationSettings.applicationName) {
        case 'ELVARLI':
          return new ElvarliDrawer(args);
        default:
          return new Item(args);
      }
    }
    case 'mounting-rail':
      switch (applicationSettings.applicationName) {
        case 'BOAXEL':
          return new BoaxelMountingRail(args);
        case 'AURDAL': {
          return new AurdalMountingRail(args);
        }
        default:
          return new Item(args);
      }
    case 'sidewall':
      return new Sidewall(args);
    case ITEMS.TABLE:
      switch (applicationSettings.applicationName) {
        case 'BOAXEL':
          return new BoaxelTable(args);
        default:
          return new Item(args);
      }
    default:
      switch (applicationSettings.applicationName) {
        case 'BOAXEL':
          return new BoaxelItem(args);
        default:
          return new Item(args);
      }
  }
}
